/**
 * API configuration.
 * Base URL for all API requests, sourced from environment or defaulting to /api/v1.
 */
export const API_BASE_URL: string =
  import.meta.env.VITE_API_BASE_URL || '/api/v1';

/**
 * Default pagination settings.
 */
export const DEFAULT_PAGE_SIZE = 20;
export const MAX_PAGE_SIZE = 100;

/**
 * Request timeout in milliseconds.
 */
export const REQUEST_TIMEOUT = 30_000;
